import { useQuery } from '@tanstack/react-query'
import { colorsService } from '@/api/services/colors.service'
import { getWpcauthForExternalApi } from '@/api/services/auth.service'
import { queryKeys } from '@/api/query-keys'

export function useColorStylesQuery() {
  const hasAuth = Boolean(getWpcauthForExternalApi())

  return useQuery({
    queryKey: queryKeys.colors.styles(),
    queryFn: colorsService.getColorStyles,
    enabled: hasAuth,
    staleTime: Infinity,
    gcTime: Infinity,
    retry: 1,
    refetchOnWindowFocus: false,
  })
}
